import React, { useState } from "react";
import { useNavigate,useHistory  } from "react-router-dom";
import { generatePath } from "react-router";
import {apiUrl, domainUrl} from '../constant';
import {authtoken} from '../global.js';
import {authHeader,authToken} from '../helpers/auth-header';
import axios from 'axios';
const axios1 = require("axios");

export const timesheetService = {
    gettimesheet,
    getSingletimesheet,
    getteammembers,
    getallclient,
    getallsubclient,
    getallsubclient_post,
    getallsubclienttemp,
    mapclient,
    getsubclientlistallspecific,
    gettasks,
    selusrtms,
    gettimesheetlists,
    addtimesheet,
    newappaddtimesheet,
    updatetimesheet,
    deletetimesheet,
    getremaining_hrs,
    approve_tms,
    approve_tms_data,
    approver_edited_tms,
    gettimesheetlistswithperiod,
    updateapptimesheet,
    savebkdata,
    allclientandsubclient,
    addclient,
    update_enabledclient,
    gettmclientlists,
    renametmclientsubclient,
    getuserslistsasper,
    getuserassign,
    deletetm,
    addbudgetclient,
    getclientwisebudget,
    getclientwisebudget2,
    updatebudgetclient,
    sendforapproval,
    finalapprove,
    isdatalocked,
    saveremarks,
    multifinalapprove,
    updatesubclientadjustmanual,
    getsubclientadjustmanual,
    getmanualdata,
    removeautoobjdb,
    savemanual,
    approver_rework,
    forgotpassword__,
    toggleclientstatus,
    addholiday,
    getholiday,
    deleteholiday,
    getparticularholiday,
    getfinaladjustment,
    deletefinaladjustment,
    updatefinaladjustment,
    multitargethoursupdate,
    getmultitargethours,
    getmultitargethoursadjustment,
    editmultitargethours,
    updatebudgethours,
    resetbudgethours,
    updateapptimesheet2,
    multilock,
    multiverifybk,
    multisendforapproval,
    getsubclientlistall,
    subclientmerger,
    updateRds,
    deletetimesheetadmin,
    showreport_gettimesheetadmin,
    updatebillingtype,
    getbillingtype,
    updateadjustment,
    multiclienttargethoursinsert,
    getmulticlienttargethours,
    multiclienttargethoursupdate,
    gettargetadjustment,
    updateadjustmentvalue,
    deleteClienttarget,
    delete_target_adjustment_tbl,
    uploadBulkTimesheet,
    download_sample,
    uploadBulkUsers,
    downloadusers_sample,
    getclientallocationpercentage,
    updateclientallocationpercentage,
    deletepercentage,
    getparticularpercentage,
    approve_all,
    powerbiupdate,
    updateclienttargetuploadtopoweri
    // deletetarget,
    
};

function addholiday(obj){
  let objdata = JSON.parse(obj);
  return axios({
    method: "post",
    url: `${apiUrl}/api/addholiday`,
    data: objdata,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
        // console.log("response");
        // console.log(response);
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function getholiday(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getholiday`,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
        // console.log("response");
        // console.log(response);
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function deleteholiday(id){
  let obj = {'id':id};
  return axios({
    method: "post",
    url: `${apiUrl}/api/deleteholiday`,
    data:obj,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
        // console.log("response");
        // console.log(response);
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function getparticularholiday(year){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getparticularholiday?year=${year}`,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
        // console.log("response");
        // console.log(response);
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function forgotpassword__(obj){
  const _month = '';
  const _member = '';
  const requestQuery = {selectedmnths: _month, selectedmember: _member};
  return axios({
      method: "post",
      url: `${apiUrl}/api/forgotpassword123`,
      data: obj,
      
    })
      .then(function (response) {
          // console.log("response");
          // console.log(response);
         if(response.status == 200){
          // console.log("response");
          // console.log(response);
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });
}

function gettimesheet({month,member}){
    // bodyFormData.append("email", email);
    // bodyFormData.append("password", password);
    // const userAuthdata = {"email":email,"password":password};
    const _month = month;
    const _member = member;
    const requestQuery = {selectedmnths: _month, selectedmember: _member};
    return axios({
        method: "post",
        url: `${apiUrl}/api/gettimesheetstatusmnth`,
        data: requestQuery,
        headers: {Authorization: `Bearer ${authToken()}` },
      })
        .then(function (response) {
            // console.log("response");
            // console.log(response);
           if(response.status == 200){
            // console.log("response");
            // console.log(response);
          }
          return response;
        }, error => {
          return error.response;
          // console.log(error.response.status);
        })
        .catch(function (error) {
          // console.log(error.response.status);
        }); 
}

function deletetimesheet({id,emp_id}){
  return axios({
    method: "get",
    url: `${apiUrl}/api/deletetimesheet?tmid=${id}&&empid=${emp_id}`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
            
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });    
}


function getSingletimesheet({date,user}){
  return axios({
      method: "get",
      url: `${apiUrl}/api/gettimesheetsingle?date=${date}&&user=${user}`,
      // data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
          // console.log("response");
          // console.log(response);
         if(response.status == 200){
              
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
}

function getteammembers({managerid}){
  let selectedmanagerid = managerid;
  return axios({
      method: "get",
      url: `${apiUrl}/api/getteammembers?managerid=${selectedmanagerid}`,
      // data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
          // console.log("response");
          // console.log(response);
         if(response.status == 200){
              
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
}

function getallclient(){
  return axios({
      method: "get",
      url: `${apiUrl}/api/allclients`,
      // data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
         if(response.status == 200){
                  
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
}

function getallsubclient({client}){
  return axios({
      method: "get",
      url: `${apiUrl}/api/allsubclients?client=${client}`,
      // data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
         if(response.status == 200){
                  
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
}

// POST version of getallsubclient: client goes in the body, so names with & or ' are sent intact
function getallsubclient_post({client}){
  return axios({
      method: "post",
      url: `${apiUrl}/api/allsubclients_post`,
      data: {client: client},
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
        return response;
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
}

function getallsubclienttemp({client}){
  let obj = {'client':client};
  return axios({
      method: "post",
      url: `${apiUrl}/api/allsubclientstemp`,
      data: obj,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
         if(response.status == 200){
                  
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
}

function gettasks(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/gettasks`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function selusrtms({obj}){
  // console.log(obj);
  let tsdate = obj.date;
  let teamsid = obj.userid; 
  let get_url = '';
  if(obj.todate){
     get_url = `${tsdate}&&todate=${obj.todate}&&teamsid=${teamsid}`;
  }else{
     get_url = `${tsdate}&&teamsid=${teamsid}`;
  }
  return axios({
    method: "get",
    url: `${apiUrl}/api/selusrtms?tsdate=${get_url}`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });  
}

function gettimesheetlists({empid}){
  const _empid = empid;
  
  // const requestQuery = {selectedmnths: _month, selectedmember: _member};
  return axios({
      method: "get",
      url: `${apiUrl}/api/gettimesheet?employee=${_empid}`,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
          // console.log("response");
          // console.log(response);
         if(response.status == 200){
          // console.log("response");
          // console.log(response);
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
}


function gettimesheetlistswithperiod({empid,period}){
  const _empid = empid;
  let _period = period; 
  
  // const requestQuery = {selectedmnths: _month, selectedmember: _member};
  return axios({
      method: "get",
      url: `${apiUrl}/api/gettimesheetwithperiod?employee=${_empid}&&period=${_period}`,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
          // console.log("response");
          // console.log(response);
         if(response.status == 200){
          // console.log("response");
          // console.log(response);
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
}

function addtimesheet({formdata}){
  let requestQuery =  JSON.parse(formdata); 
  console.log(requestQuery);
  return axios({
    method: "post",
    url: `${apiUrl}/api/newaddtimesheet`,
    data:requestQuery,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });  
}

function mapclient({formdata}){
  let requestQuery =  JSON.parse(formdata); 
  console.log(requestQuery);
  return axios({
    method: "post",
    url: `${apiUrl}/api/mapclient`,
    data:requestQuery,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });  
}

function newappaddtimesheet({formdata}){
  let requestQuery =  JSON.parse(formdata); 
  // console.log(requestQuery);
  return axios({
    method: "post",
    url: `${apiUrl}/api/newappaddtimesheet`,
    data:requestQuery,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });  
}

function updatetimesheet({formdata}){
  let requestQuery =  JSON.parse(formdata); 
  // console.log(requestQuery);
  return axios({
    method: "post",
    url: `${apiUrl}/api/updatetimesheet`,
    data:requestQuery,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });
}


function  updateapptimesheet2({formdata}){
  let requestQuery =  JSON.parse(formdata); 
  // console.log(requestQuery);
  return axios({
    method: "post",
    url: `${apiUrl}/api/updateapptimesheet2`,
    data:requestQuery,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });
}

function  updateapptimesheet({formdata}){
  let requestQuery =  JSON.parse(formdata); 
  // console.log(requestQuery);
  return axios({
    method: "post",
    url: `${apiUrl}/api/updateapptimesheet`,
    data:requestQuery,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });
}

function getsubclientlistallspecific({clientid}){
  const _clientid = clientid;

  console.log('cleint id');
  console.log(_clientid);
  // const requestQuery = {selectedmnths: _month, selectedmember: _member};
  return axios({
      method: "get",
      url: `${apiUrl}/api/getsubclientlistallspecific?mainclientid=${_clientid}`,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
          // console.log("response");
          // console.log(response);
         if(response.status == 200){
          // console.log("response");
          // console.log(response);
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
}

function getremaining_hrs({clientid,subclientid,date}){
 
  const _clientid = clientid;
  const _subclientid = subclientid;
  let obj = {'client': _clientid,'subclient': _subclientid,'filling_date':date};
  console.log(obj);
  return axios({
      method: "post",
      url: `${apiUrl}/api/getremainingHrs`,
      data:obj, 
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
          // console.log("response");
          // console.log(response);
         if(response.status == 200){
          // console.log("response");
          // console.log(response);
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
}

function approve_all({obj}){
  return axios({
    method: "get",
    url: `${apiUrl}/api/approve_all?tsdate=${obj.tsdate}&&userid=${obj.userid}`,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
        // console.log("response");
        // console.log(response);
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function approve_tms({obj}){
  return axios({
    method: "get",
    url: `${apiUrl}/api/approve_tms?tsdate=${obj.tsdate}&&userid=${obj.userid}`,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
        // console.log("response");
        // console.log(response);
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function approve_tms_data({obj}){
  return axios({
    method: "get",
    url: `${apiUrl}/api/approve_tms_data?ts_ids=${obj.ts_ids}&&userid=${obj.userid}`,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
        // console.log("response");
        // console.log(response);
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function approver_edited_tms({obj}){
  let requestform = {'ts_data':obj};
  return axios({
    method: "post",
    url: `${apiUrl}/api/approver_editedtms`,
    data:requestform,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
        // console.log("response");
        // console.log(response);
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function savebkdata({formdata}){
  let requestQuery =  JSON.parse(formdata); 
  console.log(requestQuery);
  return axios({
    method: "post",
    url: `${apiUrl}/api/savebkdata`,
    data:requestQuery,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });  
}

function allclientandsubclient(client,{projectid}){
  let obj = {'client':client,'projectid':projectid};
  return axios({
    method: "post",
    url: `${apiUrl}/api/allclientandsubclient`,
    data:obj,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    }); 
}

function addclient({formdata}){
  let obj = JSON.parse(formdata);
  return axios({
    method: "post",
    url: `${apiUrl}/api/addclient`,
    data:obj,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    }); 
}

function update_enabledclient({formdata}){
  let obj = JSON.parse(formdata);
  return axios({
    method: "post",
    url: `${apiUrl}/api/update_enabledclient`,
    data:obj,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    }); 
}

function gettmclientlists({formdata}){
  let obj = JSON.parse(formdata);
  return axios({
    method: "post",
    url: `${apiUrl}/api/gettmclientlists`,
    data:obj,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    }); 
}

function renametmclientsubclient({formdata}){
  let obj = {data:JSON.parse(formdata)};
  return axios({
    method: "post",
    url: `${apiUrl}/api/renametmclientsubclient`,
    data:obj,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });
}

function getuserslistsasper(){
 
  return axios({
    method: "get",
    url: `${apiUrl}/api/getuserslistsasper`,
    // data:obj,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });
}


function getuserassign(){
 
  return axios({
    method: "get",
    url: `${apiUrl}/api/getuserassign`,
    // data:obj,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });
}

function deletetm(id){
  return axios({
    method: "get",
    url: `${apiUrl}/api/deletetm?id=${id}`,
    // data:obj,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });
}

function addbudgetclient({formdata}){
  let obj = JSON.parse(formdata);
  return axios({
    method: "post",
    url: `${apiUrl}/api/addbudgetclient`,
    data:obj,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });
}

function getclientwisebudget({formdata}){
  let obj = JSON.parse(formdata);
  return axios({
    method: "post",
    url: `${apiUrl}/api/getclientwisebudget`,
    data:obj,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });
}

function getclientwisebudget2({formdata}){
  let obj = JSON.parse(formdata);
  return axios({
    method: "post",
    url: `${apiUrl}/api/getclientwisebudget2`,
    data:obj,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });
}

function updatebudgetclient({formdata}){
  let obj = {'data':JSON.parse(formdata)};

  return axios({
    method: "post",
    url: `${apiUrl}/api/updatebudgetclient`,
    data:obj,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });
}

function sendforapproval({formdata}){
  let obj = JSON.parse(formdata);
   return axios({
    method: "post",
    url: `${apiUrl}/api/sendforapproval`,
    data:obj,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });
}

function finalapprove({formdata}){
  let obj = JSON.parse(formdata);
  return axios({
   method: "post",
   url: `${apiUrl}/api/finalapprove`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
}

function isdatalocked({formdata}){
  let obj = JSON.parse(formdata);
  return axios({
   method: "post",
   url: `${apiUrl}/api/isdatalocked`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
  //  console.log(formdata);
}


function saveremarks({formdata}){
  let obj = JSON.parse(formdata);
  return axios({
   method: "post",
   url: `${apiUrl}/api/saveremarks`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
}

function multifinalapprove({formdata}){
  let obj = JSON.parse(formdata);
  return axios({
   method: "post",
   url: `${apiUrl}/api/multifinalapprove`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
}

function updatesubclientadjustmanual({formdata}){
  let obj = JSON.parse(formdata);
  return axios({
   method: "post",
   url: `${apiUrl}/api/updatesubclientadjustmanual`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
}

function getsubclientadjustmanual({formdata}){
  // let obj = JSON.parse(formdata);
  return axios({
   method: "get",
   url: `${apiUrl}/api/getsubclientadjustmanual?fromdate=${formdata.fromdate}&&client_id=${formdata.client}`,
  //  data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
}

function getmanualdata({formdata}){
  let obj =  formdata;
   return axios({
    method: "post",
    url: `${apiUrl}/api/getmanualdata`,
    data:obj,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });
}

function removeautoobjdb(id){
  let obj = {'id':id};
  return axios({
   method: "post",
   url: `${apiUrl}/api/removeautoobjdb`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
}

function savemanual({formdata}){
  let obj = JSON.parse(formdata);
  return axios({
   method: "post",
   url: `${apiUrl}/api/savemanual`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
}

function approver_rework(formdata){
  let obj = formdata;
  return axios({
   method: "post",
   url: `${apiUrl}/api/approver_rework`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
}

function toggleclientstatus(client,status){
  let obj = {'client': client,'status':status};
  return axios({
   method: "post",
   url: `${apiUrl}/api/toggleclientstatus`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });  
}

function getfinaladjustment(objdata){
  let obj = objdata;
  return axios({
   method: "post",
   url: `${apiUrl}/api/getfinaladjustment`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
}

function deletefinaladjustment(objdata){
  let obj = objdata;
  return axios({
   method: "post",
   url: `${apiUrl}/api/deletefinaladjustment`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
}

function updatefinaladjustment(objdata){
  let obj = objdata;
  return axios({
   method: "post",
   url: `${apiUrl}/api/updatefinaladjustment`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
}

function multitargethoursupdate(objdata){
  let obj = objdata;
  return axios({
   method: "post",
   url: `${apiUrl}/api/multitargethoursupdate`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
}

function editmultitargethours(objdata){
  let obj = objdata;
  return axios({
   method: "post",
   url: `${apiUrl}/api/editmultitargethours`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
}

function getmultitargethours(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getmultitargethours`,
   //  data:obj,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });
}

function getmultitargethoursadjustment(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getmultitargethoursadjustment`,
   //  data:obj,
    headers: { Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
      //  if(response.status == 200){
            return response;  
      //  }
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
       console.log(error);
       return error;
      // console.log(error.response.status);
    });
}

function updatebudgethours(objdata){
  let obj = objdata;
  return axios({
   method: "post",
   url: `${apiUrl}/api/updatebudgethours`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
}

function resetbudgethours(objdata){
  let obj = objdata;
  return axios({
   method: "post",
   url: `${apiUrl}/api/resetbudgethours`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
}

function multilock(objdata){
  let obj = objdata;
  return axios({
   method: "post",
   url: `${apiUrl}/api/multilock`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
}

function multiverifybk(objdata){
  let obj = objdata;
  return axios({
   method: "post",
   url: `${apiUrl}/api/multiverifybk`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
}


function multisendforapproval(objdata){
  let obj = objdata;
  return axios({
   method: "post",
   url: `${apiUrl}/api/multisendforapproval`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });
}

function getsubclientlistall(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getsubclientlistall`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;  
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function subclientmerger(objdata){
  let obj = objdata;
  return axios({
   method: "post",
   url: `${apiUrl}/api/subclientmerger`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });  
}

function updateRds(objdata){
  let obj = objdata;
  
  return axios({
   method: "post",
   url: `${apiUrl}/api/extractrds_manual`,
   data:obj,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });  
}


function deletetimesheetadmin(objdata){
  let obj = objdata;
  
  return axios({
   method: "get",
   url: `${apiUrl}/api/deletetmsadmin?id=${obj}`,
   headers: { Authorization: `Bearer ${authToken()}` },
 })
   .then(function (response) {
     //  if(response.status == 200){
           return response;  
     //  }
   }, error => {
     return error.response;
     // console.log(error.response.status);
   })
   .catch(function (error) {
      console.log(error);
      return error;
     // console.log(error.response.status);
   });  
}

function showreport_gettimesheetadmin({date,userid,_pageno}){
  return axios({
    method: "get",
    url: `${apiUrl}/api/showreport_gettimesheetadmin?date=${date}&&employeeid=${userid}&&page=${_pageno}`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;  
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function updatebillingtype(date,type){

  return axios({
    method: "get",
    url: `${apiUrl}/api/updatebillingtype?date=${date}&&type=${type}`,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
          return response;  
       }else{
          return response;
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}


function getbillingtype(date,type){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getbillingtype?date=${date}&&type=${type}`,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;  
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function updateadjustment(obj){
  return axios({
     method: "post",
     url: `${apiUrl}/api/updateadjustment`,
     data: obj,
     headers: {Authorization: `Bearer ${authToken()}`}
  })
    .then(function (response) {
       return response;  
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function multiclienttargethoursinsert(obj){
  return axios({
    method: "post",
    url: `${apiUrl}/api/multiclienttargethoursinsert`,
    data: obj,
    headers: {Authorization: `Bearer ${authToken()}`}
 })
   .then(function (response) {
      return response;  
   }, error => {
     return error.response;
     console.log(error.response.status);
   })
   .catch(function (error) {
     // console.log(error.response.status);
   });
}

function multiclienttargethoursupdate(obj){
  return axios({
    method: "post",
    url: `${apiUrl}/api/multiclienttargethoursupdate`,
    data: obj,
    headers: {Authorization: `Bearer ${authToken()}`}
 })
   .then(function (response) {
      return response;  
   }, error => {
     return error.response;
     console.log(error.response.status);
   })
   .catch(function (error) {
     // console.log(error.response.status);
   });
}

function getmulticlienttargethours(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getmulticlienttargethours`,
    headers: {Authorization: `Bearer ${authToken()}`}
 })
   .then(function (response) {
      return response;  
   }, error => {
     return error.response;
     console.log(error.response.status);
   })
   .catch(function (error) {
     // console.log(error.response.status);
   });
}

function gettargetadjustment(userid,from_date,to_date){
  return axios({
    method: "get",
    url: `${apiUrl}/api/gettargetadjustment?userid=${userid}&&from_date=${from_date}&&to_date=${to_date}`,
    headers: {Authorization: `Bearer ${authToken()}`}
 })
   .then(function (response) {
      return response;  
   }, error => {
     return error.response;
     console.log(error.response.status);
   })
   .catch(function (error) {
     // console.log(error.response.status);
   });
}

function updateadjustmentvalue(obj){
  
  return axios({
    method: "post",
    url: `${apiUrl}/api/updateadjustmentvalue`,
    data:obj,
    headers: {Authorization: `Bearer ${authToken()}`}
 })
   .then(function (response) {
      return response;  
   }, error => {
     return error.response;
     console.log(error.response.status);
   })
   .catch(function (error) {
     // console.log(error.response.status);
   });
}
function deleteClienttarget(obj){
  return axios({
    method: "post",
    url: `${apiUrl}/api/deleteClienttarget`,
    data:obj,
    headers: {Authorization: `Bearer ${authToken()}`}
 })
   .then(function (response) {
      return response;  
   }, error => {
     return error.response;
     console.log(error.response.status);
   })
   .catch(function (error) {
     // console.log(error.response.status);
   });
}

function delete_target_adjustment_tbl(obj){
  return axios({
    method: "post",
    url: `${apiUrl}/api/delete_target_adjustment_tbl`,
    data:obj,
    headers: {Authorization: `Bearer ${authToken()}`}
 })
   .then(function (response) {
      return response;  
   }, error => {
     return error.response;
     console.log(error.response.status);
   })
   .catch(function (error) {
     // console.log(error.response.status);
   });
}

function uploadBulkTimesheet({file}){
  let requestQuery = file;
  return axios({
    method: "post",
    url: `${apiUrl}/api/uploadBulkTimesheet`,
    data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
       
      }
      return response;
    }, error => {
      return error.response;
      
    })
    .catch(function (error) {
    }); 
}
function download_sample(){
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/api/download_sample`,
    headers: { Authorization: `Bearer ${authToken()}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `sample.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  

}


function uploadBulkUsers({file}){
  let requestQuery = file;
  return axios({
    method: "post",
    url: `${apiUrl}/api/uploadBulkUsers`,
    data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
       
      }
      return response;
    }, error => {
      return error.response;
      
    })
    .catch(function (error) {
    }); 
}

function downloadusers_sample(){
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/api/downloadusers_sample`,
    headers: { Authorization: `Bearer ${authToken()}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `users_sample_template.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  

}

function getclientallocationpercentage(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getclientallocationpercentage`,
    headers: { Authorization: `Bearer ${authToken()}`},
  })
  .then(function (response) {
       return response
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}

function updateclientallocationpercentage(data){
  let objdata = data;
  return axios({
    method: "post",
    url: `${apiUrl}/api/updateclientallocationpercentage`,
    data: objdata,
    headers: { Authorization: `Bearer ${authToken()}`},
  })
  .then(function (response) {
       return response
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}


function deletepercentage(id){
  return axios({
    method: "get",
    url: `${apiUrl}/api/deletepercentage?id=${id}`,
    headers: { Authorization: `Bearer ${authToken()}`},
  })
  .then(function (response) {
       return response
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}

function getparticularpercentage(client){
  let data = {
    'client':client
  };
  return axios({
    method: "post",
    url: `${apiUrl}/api/getparticularpercentage`,
    headers: { Authorization: `Bearer ${authToken()}`},
    data:data
  })
  .then(function (response) {
       return response
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });     
}

function powerbiupdate(date){
  return axios({
    method: "get",
    url: `${apiUrl}/api/dumtargethours?date=${date}`,
    headers: { Authorization: `Bearer ${authToken()}`},
  })
  .then(function (response) {
       return response
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });     
}

function updateclienttargetuploadtopoweri({month={},year={}}){
   return axios({
    method: "get",
    url: `${apiUrl}/api/clienttargetuploadtopoweri?month=${month}&&year=${year}`,
    headers: { Authorization: `Bearer ${authToken()}`},
  })
  .then(function (response) {
       return response
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    }); 
}
       








